export const adminUsers = {
    namespaced: true,
    state: {
        filter: {
            user_id: null,
            email: null,
            first_name: null,
            last_name: null,
            sort_column: 'id',
            sort_direction: 'asc'
        },

        pagination: {
            currentPage: 1,
            totalPages: 1,
            totalCount: 0,
            perPage: '50'
        }
    },

    getters: {
        filter(state) {
            return state.filter;
        },

        pagination(state) {
            return state.pagination;
        }
    },

    mutations: {
        setFilter(state, data) {
            state.filter = data;
        },

        setPagination(state, data) {
            state.pagination = data;
        },

        setPaginationCurrentPage(state, data) {
            state.pagination.currentPage = data;
        },

        setPaginationTotalPages(state, data) {
            state.pagination.totalPages = data;
        },

        setPaginationTotalCount(state, data) {
            state.pagination.totalCount = data;
        }
    }
};

export default adminUsers;
